import { Box, Divider, List } from "@chakra-ui/react"
import React, { useEffect, useRef } from "react"
import { useInViewport } from "react-in-viewport"
import { ExtendedPhoneDeviceFragment } from "../../graphql"
import { PhoneDeviceListItem } from "./PhoneDeviceListItem"

export type PhoneDevicesListProps = {
	phoneDevices: ExtendedPhoneDeviceFragment[]
	loadMore?: () => void
}

export const PhoneDevicesList: React.FC<PhoneDevicesListProps> = ({ phoneDevices, loadMore }) => {
	const ref = useRef()

	const { inViewport } = useInViewport(ref as any, { threshold: 0.25 })

	useEffect(() => {
		if (inViewport) {
			loadMore?.()
		}
	}, [inViewport, loadMore])

	return (
		<List spacing={2}>
			{phoneDevices.map((device) => (
				<React.Fragment key={device._id}>
					<PhoneDeviceListItem phoneDevice={device} />
					<Divider />
				</React.Fragment>
			))}
			<Box w="full" h="2" ref={ref as any} />
		</List>
	)
}
